export default function toDeliveryDateFormat(dateStr) {
  // expected format: DD-MM-YYYY
  const [day, month, year] = dateStr.split("-").map(Number);

  // JS month is 0-based
  const d = new Date(year, month - 1, day);

  const days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const dayName = days[d.getDay()];
  const monthName = months[d.getMonth()];
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${dayName} ${monthName} ${dd} ${yyyy} 00:00:00`;
}
